module.exports = __webpack_public_path__ + "static/media/image71.066c55a4.png";